(function () {
  var STORAGE_PREFIX = 'kleem_social_proof_';
  var VIEWING_TICK_MS = 25000;
  var VIEWING_STEP = 4;
  var BOUGHT_WINDOW_MS = 24 * 60 * 60 * 1000;

  function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function readCache(key) {
    try {
      return JSON.parse(window.localStorage.getItem(key));
    } catch (e) {
      return null;
    }
  }

  function writeCache(key, data) {
    try {
      window.localStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
      // localStorage unavailable (private mode, disabled, etc.) - the
      // widget still works for this page view, it just won't persist.
    }
  }

  function initSocialProof(root) {
    var productId = root.getAttribute('data-product-id');
    if (!productId) return;

    var viewingMin = parseInt(root.getAttribute('data-viewing-min'), 10) || 6;
    var viewingMax = parseInt(root.getAttribute('data-viewing-max'), 10) || 54;
    var boughtMin = parseInt(root.getAttribute('data-bought-min'), 10) || 40;
    var boughtMax = parseInt(root.getAttribute('data-bought-max'), 10) || 180;

    var storageKey = STORAGE_PREFIX + productId;
    var cache = readCache(storageKey) || {};
    var now = Date.now();

    // "Viewing now": pick once, then only ever move by a small step so it
    // never jumps to a wildly different number between page loads.
    if (typeof cache.viewing !== 'number') {
      cache.viewing = randomInt(viewingMin, viewingMax);
    } else {
      cache.viewing = clamp(cache.viewing, viewingMin, viewingMax);
    }

    // "Bought in the last 24h": stays fixed for the whole rolling window,
    // only re-rolled once that window has fully elapsed.
    if (
      typeof cache.bought !== 'number' ||
      !cache.boughtWindowStart ||
      now - cache.boughtWindowStart > BOUGHT_WINDOW_MS
    ) {
      cache.bought = randomInt(boughtMin, boughtMax);
      cache.boughtWindowStart = now;
    }

    writeCache(storageKey, cache);

    var viewingEl = root.querySelector('[data-social-proof-viewing-count]');
    var boughtEl = root.querySelector('[data-social-proof-bought-count]');
    var viewingRow = root.querySelector('[data-social-proof-viewing-row]');
    var boughtRow = root.querySelector('[data-social-proof-bought-row]');

    if (viewingEl) {
      viewingEl.textContent = cache.viewing;
      if (viewingRow) viewingRow.hidden = false;

      setInterval(function () {
        cache.viewing = clamp(cache.viewing + randomInt(-VIEWING_STEP, VIEWING_STEP), viewingMin, viewingMax);
        writeCache(storageKey, cache);
        viewingEl.textContent = cache.viewing;
      }, VIEWING_TICK_MS);
    }

    if (boughtEl) {
      boughtEl.textContent = cache.bought;
      if (boughtRow) boughtRow.hidden = false;
    }
  }

  function scan() {
    document.querySelectorAll('[data-product-social-proof]').forEach(function (root) {
      if (root.getAttribute('data-social-proof-init')) return;
      root.setAttribute('data-social-proof-init', 'true');
      initSocialProof(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
